if (!customElements.get('scrolling-banner')) {
  class ScrollingBanner extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init?.())
      })

      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager'
      })

      document.fonts.ready.then(() => {
        this.querySelector('.marquee')?.classList.add('marquee--animate')
      })
    }
  }

  customElements.define('scrolling-banner', ScrollingBanner)
}
